import { type MutableDatabase } from '@databases/model/database';
import { type DatabaseEntry } from '@databases/types/database';
// FIXME
// eslint-disable-next-line no-restricted-imports
import { DatabaseChangeType } from '@databases/types/redux';
// FIXME
// eslint-disable-next-line no-restricted-imports
import { addChangeToYjs } from '@databases/utils/redux/redux-to-yjs/add-change-to-yjs';

export class EntryAgent {
  private database: MutableDatabase;

  constructor(database: MutableDatabase) {
    this.database = database;
  }

  public addEntry(entry: DatabaseEntry, index?: string): void {
    addChangeToYjs(
      this.database,
      {
        type: DatabaseChangeType.ADD_ENTRY,
        entry,
        ...(index !== undefined && { index: Number(index) - 1 }), // LLM results are 1-based indexing
      },
      undefined
    );
  }

  public removeEntry(entryId: string): void {
    addChangeToYjs(
      this.database,
      {
        type: DatabaseChangeType.DELETE_ENTRY,
        entryId,
      },
      undefined
    );
  }
}
